import appStore from 'store';
import api from './api';

const store = {
    namespaced: true,
    state :{
    },
    mutations:{
    },
    actions:{
    }
}

appStore.registerModule('AgentManage', store);
